import { render, staticRenderFns } from "./LoyaltyBonusUpdateComponent.vue?vue&type=template&id=736c9f89&scoped=true"
import script from "./LoyaltyBonusUpdateComponent.vue?vue&type=script&lang=ts"
export * from "./LoyaltyBonusUpdateComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736c9f89",
  null
  
)

export default component.exports